export enum TraceLevel {
  Error = 1,
  Verbose = 2
}